import { createRouter, createWebHistory } from 'vue-router';

import { landingRoutes } from '@/router/ru/landingRoutes';
import { privacyPolicyRoutes } from '@/router/ru/privacyPolicy';
import { companyDetailsRoutes } from '@/router/ru/companyDetailsRoutes';
import { exclusiveRightsRoutes } from '@/router/ru/exclusiveRightsRoutes';
import { techStackRoutes } from '@/router/ru/techStackRoutes';
import { itActivityRoutes } from '@/router/ru/itActivityRoutes';
import { paymentRoutes } from '@/router/ru/payment';
import { emptyWidgetRoutes, widgetRoutes } from '@/router/ru/widgetRoutes';
import { errorRoutes } from '@/router/ru/errorRoutes';
import { cianRoutes } from '@/router/ru/cian';

const routes = [...landingRoutes, ...privacyPolicyRoutes, ...companyDetailsRoutes, ...exclusiveRightsRoutes, ...techStackRoutes, ...itActivityRoutes, ...paymentRoutes, ...widgetRoutes, ...emptyWidgetRoutes, ...errorRoutes, ...cianRoutes];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});

export { router, routes };
